import { UserRolesKey } from "../modules/Admin/constants";
import { FileUploadRequestBodyType } from "./types";

export class FileUploadRequestBody {
  file_name: string;
  source_file_name: string;
  content_type: string;
  constructor(obj: FileUploadRequestBodyType) {
    this.file_name = obj.fileName;
    this.source_file_name = obj.sourceFileName;
    this.content_type = obj.contentType;
  }
}

export class UserDetails {
  id: string;
  email: string;
  given_name: string;
  family_name: string;
  picture: string;
  name: string;
  username: string;
  constructor(obj: any) {
    this.email = obj?.email;
    this.family_name = obj?.family_name;
    this.given_name = obj?.given_name;
    this.picture = obj?.picture;
    this.username = obj?.username;
    this.name = obj?.given_name + " " + obj?.family_name;
    this.id = obj?.id;
  }
}

class Role {
  id: string;
  name: string;
  display_name: string;
  description: string;
  constructor(obj: any) {
    this.name = obj?.name;
    this.display_name = obj?.display_name;
    this.description = obj?.description;
    this.id = obj?.id;
  }
}

export class VerticalListResults {
  id: string;
  name: string;
  display_name: string;
  drive_link: string;
  is_enabled: boolean;
  enabled_count: object;
  last_sync_completed_at: string | null;
  constructor(obj: any) {
    this.id = obj?.id;
    this.name = obj?.name;
    this.display_name = obj?.display_name;
    this.drive_link = obj?.drive_link;
    this.is_enabled = obj?.is_enabled;
    this.enabled_count = obj?.enabled_count;
    this.last_sync_completed_at = obj?.last_sync_completed_at ?? null;
  }
}

export class ClauseCheckSummaryData {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  definition: string;
  keywords: string;
  instructions: any[];
  is_enabled: boolean;
  vertical: string;
  createdBy: string;
  updatedBy: string;

  constructor(obj: any) {
    this.id = obj?.id || "";
    this.createdAt = obj?.created_at ? new Date(obj.created_at) : new Date();
    this.updatedAt = obj?.updated_at ? new Date(obj.updated_at) : new Date();
    this.name = obj?.name || "";
    this.definition = obj?.definition || "";
    this.keywords = obj?.keywords || "";
    this.instructions = obj?.instructions || [];
    this.is_enabled = obj?.is_enabled ?? false;
    this.vertical = obj?.vertical || "";
    this.createdBy = obj?.created_by || "";
    this.updatedBy = obj?.updated_by || "";
  }
}

export class ProfileData {
  id: string;
  roles: Role[];
  is_superuser: boolean;
  module_access: string[];
  global_disabled_modules: string[];
  isPowerUser: boolean;
  isModulePowerUser: boolean;
  is_active: boolean;
  email: string;
  name: string;
  given_name: string;
  family_name: string;
  picture: string;
  request_status: string;
  request_received_on: string;
  request_status_updated_by: UserDetails;
  request_status_updated_on: string;
  user_added_by: UserDetails;
  isClauseCheckAllowed: boolean;
  isContractReviewAllowed: boolean;

  canAccessModule(moduleName: string): boolean {
    if (!moduleName) return true;
    if (this.global_disabled_modules?.includes(moduleName)) return false;
    if (this.is_superuser) return true;
    return this.module_access?.includes(moduleName);
  }

  constructor(obj: any) {
    this.id = obj?.id;
    this.email = obj?.email;
    this.family_name = obj?.family_name;
    this.given_name = obj?.given_name;
    this.name =
      (obj?.given_name + " " + obj?.family_name).trim()?.length === 0
        ? "N/A"
        : (obj?.given_name + " " + obj?.family_name).trim();
    this.picture = obj?.picture;
    this.request_status = obj?.request_status;
    this.request_received_on = obj?.request_received_on;
    this.request_status_updated_by = new UserDetails(
      obj?.request_status_updated_by
    );
    this.request_status_updated_on = obj?.request_status_updated_on;
    this.user_added_by = new UserDetails(obj?.user_added_by);
    this.roles = obj?.roles?.map((role: any) => new Role(role)) || [];
    this.is_superuser = Boolean(obj?.is_superuser);
    this.module_access = obj?.module_access || [];
    this.global_disabled_modules = obj?.global_disabled_modules || [];
    this.isModulePowerUser = this.roles?.some(
      (role: any) => role?.name === UserRolesKey.POWER_USER
    );
    this.isPowerUser =
      this.isModulePowerUser ||
      this.roles?.some((role: any) => role?.name === UserRolesKey.POWER_USER);
    this.isClauseCheckAllowed =
      this.canAccessModule("clause_check") ||
      this.roles?.some(
        (role: any) =>
          role?.name === UserRolesKey.CLAUSE_CHECK_USER
      );

    this.isContractReviewAllowed =
      this.canAccessModule("contract_review") ||
      this.roles?.some(
        (role: any) =>
          role?.name === UserRolesKey.REDLINING_USER
      );
    this.is_active = obj?.is_active;
  }
}

export class LoginUserDetails extends ProfileData {
  access_token: string;
  refresh_token: string;
  constructor(obj: any) {
    super(obj);
    this.access_token = obj?.access_token;
    this.refresh_token = obj?.refresh_token;
  }
}
